import React, { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import { useDispatch, useSelector } from "react-redux";
import { PrivateRoute, PublicRoute } from "components/routes";
import history from "config/history";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import { Toaster } from "react-hot-toast";
import AppLoader from "components/AppLoader";
import { getUserInfo } from "slices/userSlice";
import { selectIsSignedIn } from "slices/authSlice";
import AuthVerify from "auth/authVerify";
const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem("retry-lazy-refreshed") || "false"
    );
    // try to import the component
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem("retry-lazy-refreshed", "false"); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem("retry-lazy-refreshed", "true"); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};
const Login = React.lazy(() => lazyRetry(() => import("pages/login")));
const Register = React.lazy(() => lazyRetry(() => import("./pages/register")));
const Home = React.lazy(() => lazyRetry(() => import("./pages/home")));
const About = React.lazy(() => lazyRetry(() => import("./pages/about")));
const Activity = React.lazy(() =>
  lazyRetry(() => import("./pages/activity/activity"))
);
const ActivieyDetail = React.lazy(() =>
  lazyRetry(() => import("./pages/activity/activityDetails"))
);
const Judge = React.lazy(() => lazyRetry(() => import("./pages/judge")));
const Contact = React.lazy(() => lazyRetry(() => import("./pages/contact")));
const Download = React.lazy(() => lazyRetry(() => import("./pages/download")));
const Profile = React.lazy(() => lazyRetry(() => import("./pages/profile")));
const Discussion = React.lazy(() =>
  lazyRetry(() => import("./pages/discussion/discussion"))
);
const DiscussionDetails = React.lazy(() =>
  lazyRetry(() => import("./pages/discussion/discussionDetails"))
);
const ELibrary= React.lazy(() => lazyRetry(() => import("./pages/elibrary/elibrary")));
const ELibraryDetails= React.lazy(() => lazyRetry(() => import("./pages/elibrary/elibrary-details")));

const EventRegistration = React.lazy(() =>
  lazyRetry(() => import("./pages/activity/registrationForm"))
);
const UserInfo = React.lazy(() =>
  lazyRetry(() => import("./pages/userinfo"))
);
 const Quize=React.lazy(() => lazyRetry(() => import("pages/activity/quize")));
function App() {
  const dispatch = useDispatch();
  const isSignedIn = useSelector(selectIsSignedIn);

  useEffect(() => {
    if (isSignedIn) {
      dispatch(getUserInfo());
    }
  });

  return (
    <>
      <Toaster position="bottom-right" />
      <Router history={history}>
        <ScrollToTop />
        <React.Suspense fallback={<AppLoader />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <PublicRoute path="/login" component={Login} />
            <PublicRoute path="/Register" component={Register} />
            <Route path="/about" component={About} />
            <Route exact path="/activity" component={Activity} />
            <PrivateRoute path="/activity/quiz" component={Quize} />
            <Route path="/activity/register" component={EventRegistration} />
            <Route path="/activity/:id" component={ActivieyDetail} />
            <Route exact path="/gallery" component={Discussion} />
            <Route path="/gallery/details/:id" component={DiscussionDetails} />

            <Route exact path="/e-library" component={ELibrary} />
            <Route exact path="/e-library/details/:id" component={ELibraryDetails} />


            <Route path="/download" component={Download} />
            <Route path="/contact" component={Contact} />
            <Route path="/download" component={Download} />
            {/* <Route path="/user-info" component={UserInfo} /> */}
            <PrivateRoute path="/profile" component={Profile} />
            <PrivateRoute path="/judge" component={Judge} />

          </Switch>
        </React.Suspense>
      </Router>
      <AuthVerify />
    </>
  );
}

export default App;
